function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.0625 0C8.53125 0 8.9375 0.25 9.15625 0.65625L15.9062 13.1562C16.125 13.5312 16.125 14 15.875 14.4062C15.6562 14.7812 15.25 15 14.8125 15H1.3125C0.875 15 0.46875 14.7812 0.25 14.4062C0 14 0 13.5312 0.21875 13.1562L6.96875 0.65625C7.1875 0.25 7.59375 0 8.0625 0ZM8.0625 11C7.5 11 7.0625 11.4375 7.0625 12C7.0625 12.5625 7.5 13 8.0625 13C8.625 13 9.0625 12.5625 9.0625 12C9.0625 11.4375 8.625 11 8.0625 11ZM8.0625 5C7.5 5 7.03125 5.5 7.09375 6.0625L7.3125 9.3125C7.34375 9.6875 7.65625 10 8.0625 10C8.46875 10 8.78125 9.6875 8.8125 9.3125L9.03125 6.0625C9.09375 5.5 8.625 5 8.0625 5Z",
  fill: "#F9A825"
});

function SvgPhishingManagerWarningToastPrefix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhishingManagerWarningToastPrefix);
export default __webpack_public_path__ + "static/media/phishing-manager-warning-toast-prefix.72ef28c4.svg";
export { ForwardRef as ReactComponent };